'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'

import { Modal } from 'base-ui'

import { DrawerTransition } from '../../../drawer-transition'
import { type OpenableControls } from '../../../generic-hooks'

import { DynamicSellerModalContent } from './SellerModalContent/DynamicSellerModalContent'

import styles from './SellerModal.module.css'

type SellerModalProps = {
  openableControls: OpenableControls
}

export const SellerModal: FC<SellerModalProps> = ({ openableControls }) => (
  <Modal
    className={clsx(
      styles['seller-modal'],
      'flex flex-col items-end justify-end rounded-l-2xl',
    )}
    closeAfterTransition
    data-qa-id="seller-dialog"
    onClose={openableControls.handleClose}
    open={openableControls.isOpen}
  >
    <DrawerTransition
      className="mt-[120px] flex h-dvh w-full flex-col overflow-y-auto rounded-t-2xl bg-light-primary-medium tablet:mt-0 tablet:max-w-screen-tablet tablet:rounded-l-2xl tablet:rounded-tr-none"
      in={openableControls.isOpen}
    >
      <DynamicSellerModalContent />
    </DrawerTransition>
  </Modal>
)
